<template>
  <div
    id="invites-title-bar"
    class="
      title-bar
      flex flex-wrap
      justify-center
      items-center
      flex-shrink-0
      w-full
    "
  >
    <div class="logo-title absolute">
      <ul
        class="
          w-full
          flex
          justify-start
          flex-wrap
          items-center
          col-gap-12
          aisea-text-12-400-black
          h-12
        "
      >
        <li class="title-logo">
          <logo-horizontal />
        </li>
      </ul>
    </div>
    <div class="register-step flex flex-col items-center row-gap-8">
      <div class="title-text aisea-text-34-400-dark-blue">
        {{ messages.titleBar.title }}
      </div>
      <slot name="invitesWizard" />
    </div>
  </div>
</template>

<script>
import LogoHorizontal from "./LogoHorizontal.vue";

const MESSAGES = {
  titleBar: {
    title: "法人新規登録",
  },
};

export default {
  name: "Titlebar",
  mixins: [],
  props: {
    messages: { type: Object, default: () => MESSAGES },
  },
  components: {
    LogoHorizontal,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
#invites-title-bar.title-bar {
  padding-top: 50px;
  height: fit-content;
  min-height: 72px;
  .logo-title {
    max-width: 337px;
    min-height: 43px;
    top: 20px;
    left: 30px;
    ul {
      height: fit-content;
      > li {
        position: relative;
      }
    }
  }
}
</style>
